module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_MU_1bdr_D4_cam2.14dd5738.jpg";